import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { MainContainer,Cell,CellSpacer } from './styles';
import { Row, SectionTitle, Cell2, Cell50, TitleInfoIconContainer, TitleToolTipContainer, TitleToolTipText } from './styles';
import WidgetProfileCompleteness from './ProfileCompleteness';
import WidgetPublishedUpdatedPosts from './PublishedUpdatedPosts';
import WidgetViewPost from './ViewsPosts';
import WidgetEngagementPost from './EngagementPosts';
import WidgetProfileQueries from './ProfileQueries';
import WidgetProfileViews from './ProfileViews';
import WidgetProfileActions from './ProfileActions';
import info from 'common/images/icon-info.svg';

const WidgetsPerformance = () => {
    return (
        <MainContainer>
        <Row>
            <SectionTitle>
                Google Business Profile Performance
            </SectionTitle>
            <TitleInfoIconContainer>
                <img src={info}></img>
            </TitleInfoIconContainer>
            <TitleToolTipContainer>
                <TitleToolTipText>
                    These metrics only apply to your primary location.
                </TitleToolTipText>
            </TitleToolTipContainer>
        </Row>
        <Row>
            {/*
                <Cell2>
                    <WidgetProfileQueries/>
                </Cell2>
            
            <CellSpacer></CellSpacer>
            */}
            <Cell50>
                <WidgetProfileViews/>
            </Cell50>
            <CellSpacer></CellSpacer>
            <Cell50>
                <WidgetProfileActions/>
            </Cell50>
        </Row>
        <Row>
            <SectionTitle>
                Listings Manager Performance
            </SectionTitle>
        </Row>
        <Row>
            <Cell50>
                <WidgetProfileCompleteness/>
            </Cell50>
            <CellSpacer></CellSpacer>
            <Cell50>
                <WidgetPublishedUpdatedPosts/>
            </Cell50>
            {
            /*<CellSpacer></CellSpacer>
            <Cell>
                <WidgetViewPost/>
            </Cell>
            <CellSpacer></CellSpacer>
            <Cell>
                <WidgetEngagementPost/>
            </Cell>
            */}
        </Row>
        <Row>
            <SectionTitle>
                Specials Activity
            </SectionTitle>
        </Row>
        </MainContainer>
    )
}

export default WidgetsPerformance
